import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { AVAILABILITY } from '../../config/text/text';
import CollapsableSection from './shared-components/CollapsableSection';
import CalendarOnRedemptionContainer from './shared-components/booking-calendar/CalendarOnRedemptionContainerDynamic';

const MainDealAvailability = ({ deal = null, isTravel }) => {
  const [collapsed, setCollapsed] = useState(true);
  if (!deal || !deal.description) return null;

  return (
    <>
      <div className={classNames('availability')}>
        <CollapsableSection
          collapsed={collapsed}
          onToggle={() => setCollapsed((state) => !state)}
          title={AVAILABILITY}
        >
          <CalendarOnRedemptionContainer
            deal={deal}
            isCalendarOnly
            isGift={false}
            isTravel={isTravel}
          />
        </CollapsableSection>
      </div>
    </>
  );
};

MainDealAvailability.propTypes = {
  deal: PropTypes.object,
  isTravel: PropTypes.bool,
};

export default MainDealAvailability;
